import request from '@/utils/request'

export function pageComplaint(data) {
  return request({ url: '/homeservice/complaint/page', method: 'post', data })
}
export function detailComplaint(data) {
  return request({ url: '/homeservice/complaint/detail', method: 'post', data })
}
export function handleComplaint(data) {
  return request({ url: '/homeservice/complaint/handle', method: 'post', data })
}
